module.exports = __webpack_public_path__ + "img/tick-circle.5f6745f9.svg";